<ion-content class="background">
  <div class="sub-title-2">
    <ion-label>Datos del Paciente</ion-label>
  </div>

  <ion-grid class="content-resume" *ngIf="data.hasOwnProperty('patientInfo')">
    <ion-row>
      <ion-col>
        <ion-item lines="none">
          <ion-label color="tertiary">
            Nombres:
            <span class="t-bold"> {{data.patientInfo.first_name}}</span>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-label color="tertiary">
            Apellidos:
            <span class="t-bold">{{data.patientInfo.last_name}} </span>
          </ion-label>
        </ion-item>
        <ion-item lines="none" *ngIf="this.data.patientInfo.email != ''">
          <ion-label color="tertiary">
            Correo electrónico:
            <span class="t-bold"> {{data.patientInfo.email}}</span>
          </ion-label>
        </ion-item>
        <ion-item lines="none" *ngIf="this.data.patientInfo.birth_day != ''">
          <ion-label color="tertiary">
            Fecha de nacimiento (DD-MM-AAAA):
            <span class="t-bold">{{ data.patientInfo.birth_day}} </span>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-label color="tertiary">
            Identificación:
            <span class="t-bold">{{data.patientInfo.identification}} </span>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-label color="tertiary">
            Género al Nacimiento:
            <span class="t-bold">{{data.patientInfo.gender | gender}} </span>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-label color="tertiary">
            {{ "Provincia" | translate }}:
            <span class="t-bold">{{data.patientInfo.state_name}}</span>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-label color="tertiary">
            {{"Localidad" | translate }}:
            <span class="t-bold">{{data.patientInfo.city_name}}</span>
          </ion-label>
        </ion-item>
        <ion-item lines="none" *ngIf="this.data.patientInfo.address != ''">
          <ion-label color="tertiary">
            Dirección:
            <span class="t-bold">{{data.patientInfo.address}}</span>
          </ion-label>
        </ion-item>
        <ion-item lines="none">
          <ion-label color="tertiary">
            Teléfono 1
            <span class="messages-alert">(Del paciente, Familiar o Tutor)</span>:
            <span class="t-bold">{{data.patientInfo.cell_phone}} </span>
          </ion-label>
        </ion-item>
        <div *ngIf="this.data.patientInfo.cell_phone_2 != ''">
          <ion-item lines="none">
            <ion-label color="tertiary">
              Teléfono 2
              <span class="messages-alert">(Del paciente, Familiar o Tutor)</span>:
              <span class="t-bold">{{data.patientInfo.cell_phone_2}} </span>
            </ion-label>
          </ion-item>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="sub-title-2">
    <ion-label>Datos de la Solicitud</ion-label>
  </div>

  <ion-grid class="content-resume" *ngIf="data.hasOwnProperty('patientInfo')">
    <ion-row>
      <ion-col>
        <ion-item lines="none">
          <ion-label color="tertiary">
            Patología:
            <span class="t-bold">{{data.pathology_name}}</span>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary"> Manifestaciones clínicas</ion-label>
        </ion-item>

        <div>
          <div *ngFor="let manifest of data.manifests">
            <ion-item lines="none" class="manifests-list">
              <ion-label class="t-bold">
                <ion-icon name="stop-circle-outline" slot="start"></ion-icon>
                {{manifest.manifest_name}}</ion-label
              >
            </ion-item>
          </div>
        </div>

        <ion-item lines="none">
          <ion-label color="tertiary">
            Tipo de estudio:
            <span class="t-bold">{{data.study_type_name}}</span>
          </ion-label>
        </ion-item>

        <ion-item lines="none">
          <ion-label color="tertiary"> Pruebas a realizar </ion-label>
        </ion-item>

        <div>
          <div *ngFor="let test of data.test_types">
            <ion-item lines="none" class="test-types-list">
              <ion-label class="t-bold">
                <ion-icon name="checkmark" slot="start" class="t-bold"></ion-icon>
                {{test.test_types_name}}
                <span *ngIf="test.observation != ''" class="t-bold">| {{test.observation}} </span>
              </ion-label>
            </ion-item>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!-- Botones -->
  <ion-grid>
    <ion-row>
      <ion-col class="ion-text-center" size="12">
        <button (click)="create()" id="btn-create-modal" class="btn-primary-2">Registrar</button>
      </ion-col>
      <ion-col class="ion-text-center" size="12">
        <button (click)="closeModal()" id="btn-edit-modal" class="btn-primary btn-close">Editar</button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
